import React from "react";
import Modal from "react-bootstrap/Modal";
import YouTube from "react-youtube";

// styles
import * as styles from "./TwinCanHelp.module.css";

// services
import { Mixpanel, MixpanelEvents } from "../../../services/Mixpanel";

const VideoModal = props => {
  const segments = props?.videoLink.split("/") || "";
  const videoCode = segments.pop() || segments.pop();
  const sessionId = props.sessionId + "_" + videoCode;

  const opts = {
    height: "100%",
    width: "100%",
    playerVars: {
      autoplay: 1,
      rel: 0,
    },
  };

  const _onReady = event => {
    Mixpanel.track(MixpanelEvents.video_playback_started, {
      page_name: props.videoPageName ? props.videoPageName : "Homepage",
      asset: "India Website",
      asset_name: "India Corporate Website",
      session_id: sessionId,
      video_name: props.videoName,
    });
  };
  const _onPlay = event => {
    Mixpanel.track(MixpanelEvents.video_playback_resumed, {
      page_name: props.videoPageName ? props.videoPageName : "Homepage",
      asset: "India Website",
      asset_name: "India Corporate Website",
      session_id: sessionId,
      video_name: props.videoName,
    });
  };

  const _onPause = event => {
    Mixpanel.track(MixpanelEvents.video_playback_paused, {
      page_name: props.videoPageName ? props.videoPageName : "Homepage",
      asset: "India Website",
      asset_name: "India Corporate Website",
      session_id: sessionId,
      video_name: props.videoName,
    });
  };
  const _onEnd = event => {
    Mixpanel.track(MixpanelEvents.video_playback_completed, {
      page_name: props.videoPageName ? props.videoPageName : "Homepage",
      asset: "India Website",
      asset_name: "India Corporate Website",
      session_id: sessionId,
      video_name: props.videoName,
    });
    props.updateSessionId();
    setTimeout(() => {
      props.onHide();
    }, 300);
  };

  return (
    <>
      <Modal
        show={props.show}
        onHide={props.onHide}
        backdrop="static"
        keyboard={false}
        fullscreen={true}
        contentClassName={styles.newContentVideoModal}
      >
        <div className={styles.newVideoModalClose}>
          <span
            className="icon-cross"
            aria-hidden="true"
            role="presentation"
            onClick={props.onHide}
          ></span>
        </div>
        <YouTube
          style={{ width: "100%", height: "100%" }}
          videoId={videoCode}
          title={props.videoTitle ? props.videoTitle : "Twinhealth Videos"}
          opts={opts}
          onReady={_onReady}
          onPlay={_onPlay}
          onPause={_onPause}
          onEnd={_onEnd}
        />
        {/* <iframe
          title={props.videoTitle ? props.videoTitle : "Twinhealth Video Links"}
          src={props.videoLink}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          allowFullScreen
          style={{ width: "100%", height: "100%" }}
          onReady={_onReady}
          onPlay={_onPlay}
          onPause={_onPause}
          onEnd={_onEnd}
        /> */}
      </Modal>
    </>
  );
};

export default VideoModal;
